import { ScanBedContent } from "@/features/scans/components/ScanBedContent"
import { useParams } from "react-router-dom"

export default function ScanBedPage() {
  const { departmentId, bedId } = useParams()

  return <ScanBedContent departmentId={departmentId!} bedId={bedId!}/>
}